import { usePlanDetails } from './usePlanDetails';

export const useIsCashlessMatchPlan = () => {
  const planDetails = usePlanDetails();

  return planDetails?.cashlessMethodology === 'MATCH';
};
